module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.label ? 'vf-labeled' : ''
  }, [(_vm.label) ? _c('label', [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('div', [((_vm.type) === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model),
      expression: "model"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "formstate": _vm.formstate,
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.model) ? _vm._i(_vm.model, null) > -1 : (_vm.model)
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', $event.target.value)
      },
      "change": function($event) {
        var $$a = _vm.model,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.model = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model = $$c
        }
      }
    }
  }) : ((_vm.type) === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model),
      expression: "model"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "formstate": _vm.formstate,
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.model, null)
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', $event.target.value)
      },
      "change": function($event) {
        _vm.model = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model),
      expression: "model"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "formstate": _vm.formstate,
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "type": _vm.type
    },
    domProps: {
      "value": (_vm.model)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.model = $event.target.value
      }, function($event) {
        _vm.$emit('input', $event.target.value)
      }]
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "state": _vm.formstate,
      "name": _vm.name,
      "show": "$touched || $submitted"
    }
  }, [
    [_c('span', {
      staticClass: "glyphicon glyphicon-ok form-control-feedback"
    })], _vm._v(" "), _vm._l((_vm.messages), function(message, key) {
      return _c('template', {
        slot: key
      }, [_c('div', [_c('span', {
        staticClass: "glyphicon glyphicon-remove form-control-feedback"
      }), _vm._v(" "), _c('span', {
        staticClass: "has-error"
      }, [_vm._v(_vm._s(message))])])])
    })
  ], 2)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-03668864", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03668864"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utilities/FormInputCustom.vue
// module id = 2245
// module chunks = 0